// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9216a0ab","453":"47506d64","796":"3c068ed6"}[chunkId] + ".chunk.js";
};